module.exports = __webpack_public_path__ + "static/media/dumbell.e4fcb5dc.svg";